var n=(t,l,o=0)=>{let e;return(...a)=>{clearTimeout(e),e=setTimeout(()=>{l.apply(t,a)},o)}};export{n as a};
//# sourceMappingURL=chunk.BR3XNTWU.js.map
